// Force a Pages rebuild so the new VITE_ENTRA_API_SCOPE env var is baked in.
import {
  PublicClientApplication,
  type Configuration,
} from "@azure/msal-browser";

export function buildMsal(): PublicClientApplication {
  const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;
  const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;

  const config: Configuration = {
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: window.location.origin,
    },
    cache: {
      // Redirect-based auth needs persistent storage so the auth state
      // survives the full-page navigation to Microsoft and back.
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
  };

  return new PublicClientApplication(config);
}

export const API_SCOPE = import.meta.env.VITE_ENTRA_API_SCOPE;
